import moment, {MomentInput} from "moment";
import {IsoDate} from "../../pseudo-types/DateTypes";
import {Pair} from "../../types/GenericTypes";
import {DateTimeUtil} from "./DateTimeUtil";
import {Moment} from "moment-timezone";

export function weekToDate(today: MomentInput = moment()): Pair<IsoDate> {
    today = moment(today);
    const startDate = today.clone().startOf("week");
    const start = DateTimeUtil.momentToIsoDate(startDate);
    const end = DateTimeUtil.momentToIsoDate(today);
    return [start, end];
}

export function monthToDate(today: MomentInput = moment()): Pair<IsoDate> {
    today = moment(today);
    const startDate = today.clone().startOf("month");
    const start = DateTimeUtil.momentToIsoDate(startDate);
    const end = DateTimeUtil.momentToIsoDate(today);
    return [start, end];
}

export function quarterToDate(today: MomentInput = moment()): Pair<IsoDate> {
    today = moment(today);
    const startDate = today.clone().startOf("quarter");
    const start = DateTimeUtil.momentToIsoDate(startDate);
    const end = DateTimeUtil.momentToIsoDate(today);
    return [start, end];
}

export function previousQuarter(today: MomentInput = moment()): Pair<IsoDate> {
    today = moment(today);
    const current = today.quarter();
    let previous: Moment;

    if (current === 1) {
        previous = today.clone().subtract(1, "year").quarter(4);
    } else {
        previous = today.clone().quarter(current - 1);
    }

    const startDate = previous.clone().startOf("quarter");
    const start = DateTimeUtil.momentToIsoDate(startDate);
    const endDate = previous.clone().endOf("quarter");
    const end = DateTimeUtil.momentToIsoDate(endDate);

    return [start, end];
}

export function currentFinancialYearToDate(today: MomentInput = moment()): Pair<IsoDate> {
    today = moment(today);
    const [currentStart, _] = currentFinancialYear(today);
    const startDate = moment(currentStart);
    const start = DateTimeUtil.momentToIsoDate(startDate);
    const end = DateTimeUtil.momentToIsoDate(today);
    return [start, end];
}

export function previousFinancialYear(today: MomentInput = moment()): Pair<IsoDate> {
    const [currentStart, currentEnd] = currentFinancialYear(today);
    const startDate = moment(currentStart).subtract(1, "year");
    const start = DateTimeUtil.momentToIsoDate(startDate);
    const endDate = moment(currentEnd).subtract(1, "year");
    const end = DateTimeUtil.momentToIsoDate(endDate);

    return [start, end];
}

export function currentFinancialYear(today: MomentInput = moment()): Pair<IsoDate> {
    today = moment(today);
    const isInNewFinancialYear = today.month() >= 6;

    const startOfPreviousYearFinancialYear = today.clone()
                                                  .subtract(1, "year")
                                                  .month("Jul")
                                                  .startOf("month");
    const endOfPreviousYearFinancialYear = today.clone()
                                                .month("Jun")
                                                .endOf("month")
                                                .endOf("milliseconds");

    const startOfCurrentYearFinancialYear = today.clone()
                                                 .month("Jul")
                                                 .startOf("month");
    const endOfCurrentYearFinYear = today.clone()
                                         .add(1, "year")
                                         .month("Jun")
                                         .endOf("month")
                                         .endOf("milliseconds");

    const startDate = isInNewFinancialYear ? startOfCurrentYearFinancialYear : startOfPreviousYearFinancialYear;
    const start = DateTimeUtil.momentToIsoDate(startDate);
    const endDate = isInNewFinancialYear ? endOfCurrentYearFinYear : endOfPreviousYearFinancialYear;
    const end = DateTimeUtil.momentToIsoDate(endDate);

    return [start, end];
}

export function yearToDate(today: MomentInput = moment()): Pair<IsoDate> {
    today = moment(today);
    const startDate = today.clone().startOf("year");
    const start = DateTimeUtil.momentToIsoDate(startDate);
    const end = DateTimeUtil.momentToIsoDate(today);
    return [start, end];
}
